export default {
    $morePostsButton: $('#more-posts-button'),
        init() {
            let ajaxLock = false;
            if (this.$morePostsButton.length) {
                this.$morePostsButton.click(function (e) {
                    e.preventDefault();

                    let $button = e.currentTarget;

                    $($button).prop('disabled', true);

                    if (!ajaxLock) {
                        ajaxLock = true;

                        let totalPosts = wp['publishedPostsCount'];
                        let postOffset = $('.single-post').length;
                        let postsPerPage = wp['postsPerPage'];
                        let ajaxURL = wp.ajax_url;
                        let ajaxData = '&post_offset=' + postOffset + '&action=ajax_next_posts' + '&lang=' + wp.lang;

                        if (wp['postsFilter'] !== null && wp['postsFilter'] !== '') {
                            ajaxData = ajaxData + '&filter=' + wp['postsFilter']
                        }

                        $.ajax({
                            type: 'GET',
                            url: ajaxURL,
                            data: ajaxData,
                            dataType: 'json',
                            success: function (response) {
                                $('#posts-container').append(response[0]);
                                ajaxLock = false;
                                postOffset = $('.single-post').length;
                                $($button).prop('disabled', false);

                                if (totalPosts < postOffset + (postsPerPage)) {
                                    $('#more-posts').remove();
                                }
                            },
                            error: function () {
                                ajaxLock = false;
                            },
                        });
                    }
                });
            }
    },
    finalize() {
    },
    };



// WEBPACK FOOTER //
// ./scripts/routes/balance.js